"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalizedText = void 0;
const isLocalizedText = (u) => {
    if (!u)
        return false;
    const entries = Object.entries(u);
    if (entries.length === 0)
        return false;
    return entries.every(([k, v]) => typeof k === 'string' && typeof v === 'string');
};
exports.isLocalizedText = isLocalizedText;
//# sourceMappingURL=LocalizedText.js.map